<template>
    {{ uri }}
</template>

<script lang="js">
export default {
    name: 'ShareView',
    computed: {
        shareId() {
            return this.$router.payload.id;
        },
        origin() {
            return encodeURI(document.location.origin);
        },
        uri() {
            return `https://360.topomatic.ru?cloudOpenPath=${this.origin}&shareId=${this.shareId}`;
        },
    },
    mounted() {
        window.location.href = this.uri;
    },
};
</script>

<style lang="css" scoped>
</style>
